import { z } from 'zod';

/**
 * `WatermarkSettingsReturn` in the OpenAPI spec: every field besides
 * `companyId` is nullable — a company without configured watermark settings
 * gets nulls back rather than a 404.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/VESTIGAS-Admin-Company/operation/get_watermark_settings_vadmin_company__company_id__watermark_settings_get
 */
export const zodCompanyWatermarkSettingsSchema = z.object({
  companyId: z.uuid(),
  scale: z.number().min(0).max(2).nullable(),
  transparent: z.number().min(0).max(1).nullable(),
  x: z.number().int().min(0).max(595).nullable(),
  y: z.number().int().min(0).max(595).nullable(),
});
